<template lang="pug">
.quotation
  .title
    .fengefu
    span 我的资源单（{{listCount}}）
    .link(@click="isShowExportConfig=true") 生成设置

  el-table.lh14(:data="quotations" style="width: 99.9%" size="mini" ref="quotationList"
    header-row-class-name="table-header"
    :header-cell-style="{'font-size': '12px', 'height': '44px', background: '#f8f8f8', color: '#999999'}" @selection-change="handleCheck")

    el-table-column(type="selection" :width="50")
    el-table-column(label="品名" align="left" prop="pName")
    el-table-column(label="规格" align="left" prop="spec")
    el-table-column(label="材质" align="left" prop="material" )
    el-table-column(label="钢厂" align="left" prop="steelMill")
    el-table-column(label="仓库" align="left" prop="nameAbbr")
    el-table-column(label="当前价格" align="right")
      template(slot-scope="scope")
        span.price(v-if="scope.row.price") &yen;{{formatMoney(scope.row.price)}}
    el-table-column(label="会员价" align="right")
      template(slot-scope="scope")
        span.price(v-if="scope.row.price") &yen;{{formatMoney(scope.row.memberPrice)}}
    el-table-column(label="当前库存" align="right" prop="stockNum")
    el-table-column(label="操作" align="center")
      template(slot-scope="scope")
        el-button(type="text" @click="removeList(scope.row)") 删除

  .opt-bar
    .delete
      el-checkbox(@change="checkAllSelection" :indeterminate="isIndeterminate" v-model="checkAll") 全选
      el-button.btn(type="text" :disabled="itemIds.length === 0" @click="removeList('')") 删除选中资源
    .btns
      el-button.confirm-btn(type="primary" @click="showDialog" :disabled="itemIds.length === 0") 生成资源单

  quotation-dialog(v-model="isShowDialog" :data="shareQuotations" :type="type" :warehouses="newWarehouses")

  el-dialog(:visible="isShowExportConfig" @close="onCloseExportConfig" title="生成设置" width="300px")
    el-form
      el-form-item(label="显示价格")
        el-radio-group(v-model="exportPriceType")
          el-radio(:label="1") 单价
          el-radio(:label="2") 会员价
    template(slot="footer")
      .align-right
        el-button(@click="setExportConfig" type="primary") 确认
        el-button(@click="onCloseExportConfig") 取消

</template>

<script>
import NP from 'number-precision'
import QuotationDialog from './components/quotation.vue'
export default {
  name: 'Quotation',
  data() {
    return {
      list: [],
      warehouses: [],
      newWarehouses: [],
      quotations: [],
      itemIds: [],
      shareQuotations: [],
      listCount: 0,
      isShowDialog: false,
      checkAll: false,
      type: '',
      isIndeterminate: false,
      exportPriceType: 1,
      isShowExportConfig: false
    }
  },
  components: {
    QuotationDialog
  },
  mounted() {
    this.getExportList()
    this.catchExportConfig()
  },
  activated() {
    this.getExportList()
  },
  methods: {
    async catchExportConfig() {
      const result = await this.$get('items.getShareConfig')
      if (result.success) {
        const { value = 1 } = result.data[0]
        this.exportPriceType = value
      }
    },
    async setExportConfig() {
      try {
        const result = await this.$post('items.setShareConfig', {
          showPriceConfig: this.exportPriceType
        })
        if (result.success) {
          const { value = false } = result.data[0]
          value ? this.$message.success('修改成功') : this.$message.error('修改失败')
        } else {
          this.$message.error('修改失败')
        }
        this.onCloseExportConfig()
      } catch (e) {
        e
      }
    },
    onCloseExportConfig() {
      this.catchExportConfig()
      this.isShowExportConfig = false
    },
    /** 复选框 */
    handleCheck(vals) {
      this.itemIds = []
      vals &&
        vals.forEach(item => {
          this.itemIds.push(item.id)
        })
      this.isIndeterminate = this.itemIds.length > 0 && this.itemIds.length < this.listCount
      this.checkAll = this.itemIds.length >= this.listCount
    },
    // 显示弹窗
    showDialog() {
      const list = JSON.parse(JSON.stringify(this.list)) || []
      const itemIds = JSON.parse(JSON.stringify(this.itemIds)) || []
      const newList = []
      const newWarehouses = []
      const warehouseIds = []
      list.forEach(item => {
        const types = {
          partId: item.partId,
          partName: item.partName,
          shareItemVOS: []
        }
        item.shareItemVOS &&
          item.shareItemVOS.forEach(it => {
            if (itemIds.indexOf(it.id) > -1) {
              types.shareItemVOS.push(
                this.exportPriceType === 1
                  ? it
                  : {
                      ...it,
                      price: it.memberPrice
                    }
              )
              if (warehouseIds.indexOf(it.warehosId) === -1) {
                warehouseIds.push(it.warehosId)
              }
            }
          })
        if (types.shareItemVOS.length > 0) newList.push(types)
      })
      const warehoses = this.warehouses || []
      warehoses.forEach(w => {
        if (warehouseIds.indexOf(w.warehosId) > -1) {
          newWarehouses.push(w)
        }
      })
      this.shareQuotations = JSON.parse(JSON.stringify(newList))
      this.newWarehouses = JSON.parse(JSON.stringify(newWarehouses))
      this.type = 'text'
      this.isShowDialog = true
    },
    /** 获取商品列表 */
    async getExportList() {
      this.quotations = []
      this.list = []
      try {
        const result = await this.$post('items.seller.getSharesByItemIds')
        if (result.success) {
          this.list = result.data[0].partVOS || []
          this.list &&
            this.list.forEach(item => {
              if (item.shareItemVOS) this.quotations = this.quotations.concat(item.shareItemVOS)
            })
          this.warehouses = result.data[0].warehoseVOS || []
          this.listCount = result.data[0].size
          this.$store.dispatch('quotation/SET_COUNT', this.listCount)
        }
      } catch (err) {
        console.log(err)
      }
    },
    // 切换全部选择状态
    checkAllSelection() {
      if (this.checkAll) {
        this.quotations.forEach(row => {
          this.$refs.quotationList.toggleRowSelection(row, true)
        })
      } else {
        this.$refs.quotationList.clearSelection()
      }
    },
    // 删除商品
    async removeList(item) {
      const itemIds = !item ? this.itemIds : [item.id]
      if (!itemIds || itemIds.length === 0) return this.$message.error('请选择商品')
      const tips = `您确定删除${!item ? '选中的' : '该'}商品吗？`
      this.$confirm(tips, '提示', {
        center: true,
        confirmButtonText: '确认',
        cancelButtonText: '取消'
      })
        .then(async () => {
          try {
            const { data } = await this.$post('items.seller.deleteShareList', {
              querySharesDTO: {
                itemIds
              }
            })
            if (data && data[0] && data[0].value) {
              this.$message.success('操作成功')
              this.getExportList()
            }
          } catch (err) {
            console.log(err)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    formatMoney(money) {
      return NP.round(NP.divide(money, 100), 2)
    }
  }
}
</script>

<style lang="stylus" scoped>
.title
  display flex
  align-items center
  font-weight 500
  font-size 16px
  margin-bottom 16px
  margin-top 14px
  position relative
  .fengefu
    width 2px
    height 12px
    background-color #cd974c
    margin-right 15px
  .link
    position absolute
    right 0
    color: #cd974c;
    cursor pointer

.opt-bar
  display flex
  justify-content space-between
  align-items center
  position fixed
  z-index 999
  padding 0 40px
  height 70px
  background-color #fff
  box-shadow 0 -3px 10px -2px #f8f8f8
  left 185px
  bottom 0
  width calc(100vw - 185px)
  /deep/.el-checkbox
    min-width 80px
.lh14
  /deep/.cell
    line-height 1.4
    font-size 13px
    color #333
  /deep/.has-gutter
    .cell
      color #999999
.price
  color #cd974c
  font-weight 500
.quotation
  /deep/.el-checkbox__label
    color #333333 !important
    font-size 14px
  /deep/.el-button--text
    color #666666
    font-size 13px
    &:hover
      color #cd974c
  .btn
    font-weight 400
  .confirm-btn
    width 120px
    height 48px
    font-size 16px
    font-weight 700
    background linear-gradient(90deg,rgba(240,36,46,1) 0%,rgba(208,17,26,1) 100%)
.align-right
  text-align right
</style>
<style lang="scss" scoped>
.opt-bar {
  @media all and (min-width: $maxWidth) {
    left: calc(50vw - 535px);
    width: 1215px;
  }
}
</style>
